import { createFileRoute } from "@tanstack/react-router";
import { NotBuiltYet } from "@/components/NotBuiltYet";

export const Route = createFileRoute("/approvals")({
  component: () => (
    <NotBuiltYet
      title="Approvals"
      backlogId="BL-001"
      description="Approval chains for catalog requests, deferred with the catalog itself."
    />
  ),
});
